import type { Center } from '@/types/models'
import React, { useState, useEffect } from 'react'
import { MAX_HIT_COUNT } from '@/lib/constants'
import { getAdOpsCookie } from '@/domain/useCases/adminBarInfo/adminBarUtils'
import { QUERY_DEBUG_PARAM } from '@/domain/useCases/adminBarInfo/constants'
export const CarouselInfo = ({
  centers,
  count = MAX_HIT_COUNT
}: {
  centers: Center[] | []
  count?: number
}) => {
  useEffect(() => {
    if (QUERY_DEBUG_PARAM.test(window?.location?.search.toString())) {
      setCanShowAdOpsInfo(true)
    }
    if (getAdOpsCookie()) {
      setCanShowAdOpsInfo(true)
    }
    return () => {
      setCanShowAdOpsInfo(false)
    }
  }, [centers])

  const [canShowAdOpsInfo, setCanShowAdOpsInfo] = useState(false)
  const [showAdOpsInfo, setShowAdOpsInfo] = useState(false)
  const toggleShowAdOpsInfo = () => {
    setShowAdOpsInfo(!showAdOpsInfo)
  }

  if (!canShowAdOpsInfo) {
    return null
  }
  return (
    <div className="md:absolute md:ml-[-40px] md:w-[400]">
      <button
        onClick={toggleShowAdOpsInfo}
        className="z-40 rounded-md"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          className={
            showAdOpsInfo
              ? 'size-6 bg-secondary-400 fill-gray-50 stroke-gray-50'
              : `size-6 fill-secondary-400 stroke-secondary-500`
          }
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z"
          />
        </svg>
      </button>
      {showAdOpsInfo && (
        <span className="mt-2">
          <ul
            className={`absolute z-40 block gap-1 bg-primary-50 p-3 text-xs text-gray-700 shadow-md`}
          >
            {centers.slice(0, count).map((node, i) => {
              if (i + 1 <= MAX_HIT_COUNT) {
                return (
                  <li
                    key={`${node.slug}-${i}`}
                    className="space-1 flex w-fit items-start justify-evenly whitespace-nowrap"
                  >
                    {i + 1}
                    {' - '}
                    {node.title} {' - '}
                    {node?.score?.toFixed(4)}
                  </li>
                )
              }
              if (i + 1 === MAX_HIT_COUNT) {
                return (
                  <li
                    key={`${node.slug}-${i}`}
                    className="mt-1 block w-fit items-start justify-evenly whitespace-nowrap border-2 border-secondary-300 py-2 text-gray-400"
                  >
                    {i + 1}
                    {' - '}
                    {node.title} {' - '}
                    {node?.score?.toFixed(4)}
                  </li>
                )
              } else {
                return (
                  <li
                    key={`${node.slug}-${i}`}
                    className="space-1 flex w-fit items-start justify-evenly whitespace-nowrap text-gray-400 opacity-90"
                  >
                    {i + 1}
                    {' - '}
                    {node.title} {' - '}
                    {node?.score?.toFixed(4)}
                  </li>
                )
              }
            })}
          </ul>
        </span>
      )}
    </div>
  )
}
